"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _draftJs = require("draft-js");

var _Button = _interopRequireDefault(require("../Button"));

var _List = _interopRequireDefault(require("../List"));

var _richTextEditor = require("../../constants/richTextEditor");

var _lib = require("../../lib");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RichTextEditorControls =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RichTextEditorControls, _PureComponent);

  function RichTextEditorControls() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RichTextEditorControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RichTextEditorControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var value = _ref.value,
          data = _ref.data;
      (0, _lib.callEventMethods)(e, 'preventDefault');
      var _this$props = _this.props,
          editorState = _this$props.editorState,
          onChange = _this$props.onChange;

      if (onChange) {
        var newEditorState;

        if (data.type === 'BLOCK_STYLE') {
          newEditorState = _draftJs.RichUtils.toggleBlockType(editorState, value);
        }

        if (data.type === 'INLINE_STYLE') {
          newEditorState = _draftJs.RichUtils.toggleInlineStyle(editorState, value);
        }

        if ((0, _lib.objKeysHasValue)(data.metaData)) {
          var _draft$extractEditorS = _lib.draft.extractEditorStateData(editorState, ['content', 'selection']),
              content = _draft$extractEditorS.content,
              selection = _draft$extractEditorS.selection;

          var _draft$extractSelecti = _lib.draft.extractSelectionStateData(selection, ['startKey']),
              startKey = _draft$extractSelecti.startKey;

          var _draft$extractContent = _lib.draft.extractContentStateData(content, [{
            key: 'blockForKey',
            value: startKey
          }]),
              blockForKey = _draft$extractContent.blockForKey;

          var _draft$extractContent2 = _lib.draft.extractContentBlockData(blockForKey, ['data']),
              blockData = _draft$extractContent2.data;

          var newMap = new _immutable.Map(blockData);
          var keys = Object.keys(data.metaData);

          if ((0, _lib.arrayHasItems)(keys)) {
            keys.forEach(function (k) {
              var objValue = data.metaData[k];
              var mapValue = blockData.get(k);
              newMap = newMap.set(k, objValue); // toggle

              if (objValue === mapValue) {
                newMap = newMap["delete"](k);
              }
            });
          }

          var newContentState = _draftJs.Modifier.setBlockData(content, selection, newMap);

          newEditorState = _draftJs.EditorState.push(editorState, newContentState, _richTextEditor.CHANGE_BLOCK_DATA);
        }

        if (editorState !== newEditorState) {
          onChange(newEditorState);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isActive", function (item) {
      var editorState = _this.props.editorState;

      var _draft$extractEditorS2 = _lib.draft.extractEditorStateData(editorState, ['content', 'selection', 'style']),
          content = _draft$extractEditorS2.content,
          selection = _draft$extractEditorS2.selection,
          currentStyle = _draft$extractEditorS2.style;

      var _draft$extractSelecti2 = _lib.draft.extractSelectionStateData(selection, ['startKey']),
          startKey = _draft$extractSelecti2.startKey;

      var _draft$extractContent3 = _lib.draft.extractContentStateData(content, [{
        key: 'blockForKey',
        value: startKey
      }]),
          currentBlock = _draft$extractContent3.blockForKey;

      if (item.data.metaData) {
        var _draft$extractContent4 = _lib.draft.extractContentBlockData(currentBlock, ['data']),
            blockData = _draft$extractContent4.data;

        return (0, _lib.mapMatchObj)(blockData, item.data.metaData) ? 'white' : null;
      }

      if (item.data.type === 'BLOCK_STYLE') {
        var _draft$extractContent5 = _lib.draft.extractContentBlockData(currentBlock, ['type']),
            blockType = _draft$extractContent5.type;

        return item.value === blockType ? 'white' : null;
      }

      if (item.data.type === 'INLINE_STYLE') {
        return currentStyle.has(item.value) ? 'white' : null;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderControls", function (item) {
      var _this$props2 = _this.props,
          editorState = _this$props2.editorState,
          onChange = _this$props2.onChange;

      var Component = _react["default"].createElement(_Button["default"], {
        className: "MHub-RichTextEditor-Controls",
        key: item.label,
        title: item.label,
        basic: true,
        color: _this.isActive(item),
        icon: item.icon,
        onMouseDown: function onMouseDown(e) {
          return _this.handleOnChange(e, item);
        }
      });

      if (item.component) {
        var Control = item.component;
        Component = _react["default"].createElement(Control, {
          editorState: editorState,
          onChange: onChange
        });
      }

      return _react["default"].createElement(_List["default"].Item, {
        key: item.value || item.label
      }, Component);
    });

    return _this;
  }

  _createClass(RichTextEditorControls, [{
    key: "render",
    value: function render() {
      var options = this.props.options;
      return _react["default"].createElement(_List["default"], {
        data: options,
        horizontal: true,
        itemNode: this.renderControls
      });
    }
  }]);

  return RichTextEditorControls;
}(_react.PureComponent);

exports["default"] = RichTextEditorControls;

_defineProperty(RichTextEditorControls, "propTypes", {
  editorState: _propTypes["default"].instanceOf(Object).isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(_richTextEditor.CONTROLS)),
  onChange: _propTypes["default"].func
});

_defineProperty(RichTextEditorControls, "defaultProps", {
  options: null,
  onChange: null
});